
import { defineComponent } from 'vue';
import Incentives from '../Incentives/Incentives.vue';

export default defineComponent({
	components: {
		Incentives,
	},
	setup: () => {
		return {};
	},
});
